import { notifyWarn } from "../assets/elements/Toast";

export const getEntityByIdOptionWithFormatter = async (
  apiCall,
  id,
  labelFormatter,
  valueField = "publicId",
  dataPath = "data.data"
) => {
  try {
    const response = await apiCall(id);
    const data = dataPath.split(".").reduce((obj, key) => obj?.[key], response);

    if (response?.data && data) {
      const options = [
        {
          label: labelFormatter(data),
          value: data[valueField] || data.id || id,
        },
      ];

      return options;
    }
    return [];
  } catch (error) {
    console.error(`Error fetching entity with ID ${id}:`, error);
    return [];
  }
};

const getFilteredEntityOptions = async (
  apiCall,
  filters,
  fieldMapping = { labelField: "email", valueField: "publicId" },
  dataPath = "data.data.doc",
  options = {}
) => {
  const {
    showNotification = true,
    notifyFunction = notifyWarn,
    translateFunction = (msg) => msg, // Default to no translation
    additionalFilters = [],
  } = options;

  const details = {
    filters: [...filters, ...additionalFilters],
  };

  try {
    const response = await apiCall(details);
    console.log("Filter API response:", response);

    // Navigate to data using the provided path
    const dataArray = dataPath
      .split(".")
      .reduce((obj, key) => obj?.[key], response);

    if (Array.isArray(dataArray) && dataArray.length >= 0) {
      const { labelField, valueField } = fieldMapping;

      const mappedOptions = dataArray.map((item) => ({
        label: item[labelField] || "Unknown",
        value: item[valueField] || item.id,
      }));

      return mappedOptions;
    }

    return [];
  } catch (error) {
    if (showNotification && notifyFunction) {
      const errorMessage =
        error?.response?.data?.message ||
        translateFunction("An unexpected error occurred");
      notifyWarn(errorMessage);
    }
    console.error("Error fetching filtered entities:", error);
    return [];
  }
};

// Simplified version for single filter by ID
export const getEntityOptionsByFilter = async (
  apiCall,
  filterKey,
  filterValue,
  fieldMapping,
  dataPath,
  options
) => {
  const filters = [{ key: filterKey, eq: filterValue }];
  return getFilteredEntityOptions(
    apiCall,
    filters,
    fieldMapping,
    dataPath,
    options
  );
};
